<dhp-article-purchase-account-shell
  [eyebrowKey]="'pages.articlePurchase.success.eyebrow'"
  [titleKey]="'pages.articlePurchase.success.title'"
  [descriptionKey]="'pages.articlePurchase.success.description'"
  [showSummary]="false"
>
  @if (articleTitle()) {
    <div
      class="rounded-xl border border-secondary-border bg-primary-background p-4"
    >
      <p class="text-sm text-secondary-text">
        {{ 'pages.articlePurchase.success.articleLabel' | translate }}
      </p>
      <p class="mt-1 text-base font-medium text-primary-text">
        {{ articleTitle() }}
      </p>
    </div>
  }

  @if (!isPaid() && purchaseId()) {
    <div
      class="flex flex-col items-center justify-center space-y-4 py-4 text-center"
    >
      <div
        class="h-10 w-10 animate-spin rounded-full border-4 border-orange-500/30 border-t-orange-500"
      ></div>
      <p class="text-sm text-primary-text">
        {{ 'pages.articlePurchase.success.waitingForPayment' | translate }}
      </p>
    </div>
  } @else {
    <p class="text-sm text-primary-text">
      {{ 'pages.articlePurchase.success.accessInfo' | translate }}
    </p>
  }

  <div class="flex flex-col gap-3 sm:flex-row sm:items-center">
    @if (canOpenArticle()) {
      <a
        class="btn-primary btn sm:w-fit"
        [routerLink]="['/articles', articleId()]"
        [queryParams]="{ purchase: 'success' }"
      >
        {{ 'pages.articlePurchase.success.viewArticle' | translate }}
      </a>
    }
    <a class="btn-secondary btn sm:w-fit" [routerLink]="['/']">
      {{ 'pages.articlePurchase.success.backHome' | translate }}
    </a>
  </div>
</dhp-article-purchase-account-shell>
